import React from "react";
import "../style/coming-soon.css";

const ComingSoon = () => {
  return (
    <div className="coming-soon">
      <h1 className="coming-soon__title">Coming Soon</h1>
      <p className="coming-soon__subtitle">
        We are working hard to bring something amazing to you. Stay tuned!
      </p>
    </div>
  );
};

export default ComingSoon;